
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4a267634\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!./toggleButton.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./toggleButton.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4a267634\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./togglebutton.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/togglebutton/togglebutton.vue.html
// module id = tXzn
// module chunks = 2